<template>
  <vx-card>
    <div class="venues-list-container">
      <div class="venues-header">
        <div class="venues-title-section">
          <feather-icon icon="MapPinIcon" svgClasses="w-5 h-5 text-primary mr-2" />
          <h4 class="venues-title">Venues List</h4>
        </div>
        <vs-button
          v-if="addAllowed == true"
          @click="addNewData"
          type="filled"
          color="primary"
          size="small"
          icon-pack="feather"
          icon="icon-plus"
          >Add New</vs-button
        >
      </div>
      <div class="venues-table-wrapper">
        <vs-table pagination :max-items="itemsPerPage" :data="venues" search>
          <template slot="thead">
            <vs-th>Name</vs-th>
            <vs-th>Street</vs-th>
            <vs-th class="text-center">Today</vs-th>
            <vs-th class="text-center">This Week</vs-th>
            <vs-th class="text-center">This Month</vs-th>
            <vs-th>Actions</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr
              :data="tr"
              :key="indextr"
              v-for="(tr, indextr) in data"
              class="venue-table-row"
            >
              <vs-td :data="tr.name">
                <span 
                  class="venue-name cursor-pointer hover:text-primary" 
                  @click="showData(tr.id)"
                >
                  {{ tr.name }}
                </span>
              </vs-td>
              <vs-td :data="tr.street">
                <span class="venue-street">{{ tr.street }}</span>
              </vs-td>
              <vs-td :data="tr.today_bookings_count" class="text-center">
                <span class="booking-count">{{ tr.today_bookings_count }}</span>
              </vs-td>
              <vs-td :data="tr.week_bookings_count" class="text-center">
                <span class="booking-count">{{ tr.week_bookings_count }}</span>
              </vs-td>
              <vs-td :data="tr.month_bookings_count" class="text-center">
                <span class="booking-count">{{ tr.month_bookings_count }}</span>
              </vs-td>
              <vs-td class="whitespace-no-wrap action-column">
                <div class="flex items-center">
                  <feather-icon
                    v-show="showAllowed"
                    icon="EyeIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current cursor-pointer"
                    @click.stop="showData(tr.id)"
                    class="mr-2"
                  />
                  <feather-icon
                    v-show="editAllowed"
                    icon="EditIcon"
                    svgClasses="w-5 h-5 hover:text-primary stroke-current cursor-pointer"
                    @click.stop="editData(tr.id)"
                    class="mr-2"
                  />
                  <feather-icon
                    icon="TrashIcon"
                    svgClasses="w-5 h-5 hover:text-danger stroke-current cursor-pointer"
                    @click.stop="deleteData(tr)"
                  />
                </div>
              </vs-td>
            </vs-tr>

          </template>
        </vs-table>
      </div>
    </div>
  </vx-card>
</template>

<script>
import {
  _list,
  _delete,
  _deletePortal,
  _updatePortalSettings,
  _generateQR,
  _removeQR
} from "@/services/Venue";
import vSelect from "vue-select";
import { Validator } from "vee-validate";
import PortalTypes from "./PortalTypesPopup";
import OnlineDeliveryPortal from "./OnlineDelivery";
import PortalSettings from "./PortalSettings";
import ApiPortal from "./ApiPortal";
import modulePortal from "@/store/portal/modulePortalManagement.js";
import { _permissions } from "@/services/Portal";
import { _update_user_status } from "@/services/User";
import { MAIN_DOMAIN } from '@/environment'


const dict = {
  custom: {
    portal_username: {
      required: "Please enter username",
    },
    portal_password: {
      required: "Please enter password",
    },
    portal_role: {
      required: "Please select role",
    },
    portal_device: {
      required: "Please enter device address",
    },
  },
};

Validator.localize("en", dict);

export default {
  components: {
    vSelect,
    // PortalTypes,
    // OnlineDeliveryPortal,
    // PortalSettings,
    // ApiPortal,
  },
  mounted() {
    // this.$store.registerModule("portalModule", modulePortal);
  },
  beforeDestroy: function () {
    // this.$store.unregisterModule("portalModule");
  },
  data() {
    return {
      companyID: this.$store.state.company.companyID,
      venues: [],
      itemsPerPage: 9,
      // portalChoicePopup: false,
      // onlinePortalPopup: false,
      // devicePortalPopup: false,
      // apiPortalPopup: false,
      // qrPopup: false,
      // editOnlinePortalPopup: false,
      // editDevicePortalPopup: false,
      roleOptions: [
        { label: "Basic", value: "basic" },
        { label: "Reception", value: "reception" },
        { label: "Kiosk", value: "kiosk" },
      ],
      venueIndex: -1,
      // allPortals: [],
      main_domain : MAIN_DOMAIN,
      // venue_qr_exists: false

    };
  },
  computed: {
    // venue_qr_exists() {
    //   return this.selVen.qr_exists;
    // },
    selVen(){
          const selectedVenueIndex = this.venues.findIndex(
              (v) => v.id == this.venueIndex
            );
            return this.venues[selectedVenueIndex];
            // selectedVen.qr_exists = true;
    },
    // portal: {
    //   get() {
    //     return this.$store.state.portalModule;
    //   },
    // },
    itemColor() {
      return (obj) => {
        let style_obj = {}

        obj.style.forEach(p => { style_obj[p] = obj.color })

        return style_obj
      }
    },
    addAllowed() {
      const localPermission = this.$store.state.AppActiveUser.permissions;

      if (
        Object.keys(localPermission).length === 0 &&
        localPermission.constructor === Object
      )
        return true;
      else {
        if (localPermission.some((p) => p.path.includes("/venue/add"))) {
          return true;
        }
        return false;
      }
    },
    editAllowed() {
      const localPermission = this.$store.state.AppActiveUser.permissions;
      if (
        Object.keys(localPermission).length === 0 &&
        localPermission.constructor === Object
      )
        return true;
      else {
        if (localPermission.some((p) => p.path.includes("/venue/edit"))) {
          return true;
        }
        return false;
      }
    },
    showAllowed() {
      const localPermission = this.$store.state.AppActiveUser.permissions;
      if (
        Object.keys(localPermission).length === 0 &&
        localPermission.constructor === Object
      )
        return true;
      else {
        if (localPermission.some((p) => p.path.includes("/venue/view"))) {
          return true;
        }
        return false;
      }
    },
  },
  watch: {
    "$store.state.company.companyID"(val) {
      this.companyID = val;
      this.getVenues();
    },
  },
  created() {
    this.getVenues();
  },
  methods: {
    // listen() {
    //   this.$echo
    //     .join("taxipoint")
    //     .here((users) => {
    //       const onlineUsers = users.filter(
    //         (u) =>
    //           u.id !== this.$store.state.AppActiveUser.uid &&
    //           u.status === "offline"
    //       );
    //       onlineUsers.map((o) => {
    //         let model = this.allPortals.find((p) => p.user_id == o.id);
    //         if (model) {
    //           let v_idx = this.venues.findIndex((v) => v.id === model.venue_id);
    //           let selectedVenuePortals = this.venues[v_idx].portals;
    //           let p_idx = selectedVenuePortals.findIndex(
    //             (p) => p.user_id === o.id
    //           );
    //           let v_portal = selectedVenuePortals[p_idx];
    //           if (v_portal) {
    //             v_portal.user.status = "online";
    //           }
    //           this.venues[v_idx].portals.splice(p_idx, 1, v_portal);
    //         }
    //       });
    //     })
    //     .joining((user) => {
    //      this.portalJoined(user);
    //     })
    //     .leaving((user) => {
    //       this.portalLeft(user);
    //     });
    // },
    // // portalJoined(user) {
    //   let model = this.allPortals.find((p) => p.user_id === user.id); // get portal model
    //   let v_idx = this.venues.findIndex((v) => v.id === model.venue_id); // get venue index from portal model
    //   let selectedVenuePortals = this.venues[v_idx].portals; // get selected venue to update further
    //   let p_idx = selectedVenuePortals.findIndex((p) => p.user_id === user.id);
    //   let v_portal = selectedVenuePortals[p_idx]; // get portal to update
    //   if (v_portal) {
    //     v_portal.user.status = "online";
    //     _update_user_status(v_portal.user.id, { status: "online" }); // calling api
    //     this.venues[v_idx].portals.splice(p_idx, 1, v_portal);
    //   }
    // },
    // portalLeft(user) {
    //   let model = this.allPortals.find((p) => p.user_id === user.id); // get portal model
    //   let v_idx = this.venues.findIndex((v) => v.id === model.venue_id); // get venue index from portal model
    //   let selectedVenuePortals = this.venues[v_idx].portals; // get selected venue to update further
    //   let p_idx = selectedVenuePortals.findIndex((p) => p.user_id === user.id);
    //   let v_portal = selectedVenuePortals[p_idx]; // get portal to update
    //   if (v_portal) {
    //     v_portal.user.status = "offline";
    //     _update_user_status(v_portal.user.id, { status: "offline" }); // calling api
    //     this.venues[v_idx].portals.splice(p_idx, 1, v_portal);
    //   }
    // },
    getVenues() {
      this.$vs.loading();
      _list(this.companyID)
        .then(
          (response) => {
            this.$vs.loading.close();
            this.venues = response.data.obj.list;
            // this.allPortals = this.venues.flatMap((el) => el.portals);
            // this.listen();
          },
          (error) => {
            this.$vs.loading.close();
            this.$vs.notify({
              title: error.response.data.responseTitle,
              text: error.response.data.responseMessage,
              iconPack: "feather",
              icon: "icon-cross-circle",
              color: "danger",
            });
          }
        )
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            text: error.message,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
          });
        });
    },
    addNewData() {
      this.$router.push("/venue/add");
    },
    showData(id) {
      this.$router.push(`/venue/view/${id}`);
    },
    deleteData(tr) {
      this.deleteIndex = tr.id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm Delete`,
        text: `You are about to delete "${tr.display_name}"`,
        accept: this.deleteRecord,
        acceptText: "Delete",
      });
    },
    deleteRecord() {
      let id = this.deleteIndex;
      this.$vs.loading();
      _delete(id)
        .then((response) => {
          this.$vs.loading.close();
          let data = this.venues.filter((p) => p.id != id);
          this.venues = data;
          this.$vs.notify({
            title: response.data.responseTitle,
            text: response.data.responseMessage,
            iconPack: "feather",
            icon: "icon-check-circle",
            color: "success",
          });
        })
        .catch((error) => {
          this.$vs.loading.close();
          this.$vs.notify({
            title: error.response.data.responseTitle,
            text: error.response.data.responseMessage,
            iconPack: "feather",
            icon: "icon-cross-circle",
            color: "danger",
          });
        });
    },
    editData(id) {
      this.$router.push(`/venue/edit/${id}`);
    },
    setVenueIndex(venueID) {
      // this.portalChoicePopup = true;
      this.venueIndex = venueID;
      // this.venue_qr_exists = this.selVen.qr_exists == 1 ? true:false
    },
    // setPortalType(portalType) {
    //   this.errors.clear();
    //   if (portalType == "online") {
    //     this.portal.role = { label: "Basic", value: "basic" };
    //     this.onlinePortalPopup = true;
    //   } else if (portalType == "device") this.devicePortalPopup = true;
    //   else if (portalType == "delivery") {
    //     this.portal.role = { label: "Delivery", value: "delivery" };
    //     this.onlinePortalPopup = true;
    //   } else if (portalType == "api") {
    //     this.apiPortalPopup = true;
    //   }  else if (portalType == "qR-booker")
    //   {
    //     this.qrPopup = true;

    //   }
    //   this.$store.dispatch("portalModule/updatePortal", {
    //     type: portalType,
    //     venue_id: this.venueIndex,
    //     role: this.portal.role,
    //   });
    //   this.$store.dispatch("portalModule/setPortalPermission", {
    //     permissions: "",
    //   });
    // },
    
    // updatePortalUI(response, calltype = "add") {
    //   let localPortal = response.data.obj.portal;
    //   if (calltype == "edit") {
    //     this.updatePortalRow(localPortal);
    //     this.editOnlinePortalPopup = false;
    //     this.apiPortalPopup = false;
    //   } else {
    //     const selectedVenue = this.venues.find(
    //       (venue) => venue.id == localPortal.venue_id
    //     );
    //     if (selectedVenue) {
    //       selectedVenue.portals.push(localPortal);
    //     }
    //     this.onlinePortalPopup = false;
    //     this.devicePortalPopup = false;
    //     this.apiPortalPopup = false;
    //     this.portalChoicePopup = false;
    //   }
    //   this.$store.dispatch("portalModule/resetPortal");
    // },

    // editPortal(val) {
    //   if (val.type == "api") {
    //     // get portal permissions
    //     _permissions(val.id).then((res) => {
    //       this.$store.dispatch(
    //         "portalModule/setPortalPermission",
    //         res.data.obj
    //       );
    //     });
    //   }
    //   this.errors.clear();
    //   let localRole = {};
    //   switch (val.role) {
    //     case "delivery":
    //       localRole = { label: "delivery", value: "delivery" };
    //       break;
    //     case "basic":
    //       localRole = { label: "Basic", value: "basic" };
    //       break;
    //     case "reception":
    //       localRole = { label: "Reception", value: "reception" };
    //       break;
    //     case "kiosk":
    //       localRole = { label: "Kiosk", value: "kiosk" };
    //       break;
    //     default:
    //       break;
    //   }

    //   this.$store.dispatch("portalModule/updatePortal", {
    //     id: val.id,
    //     device_id: val.device_id,
    //     username: val.user.api_username,
    //     password: val.user.api_password,
    //     type: val.type,
    //     duration: val.duration,
    //     venue_id: val.venue_id,
    //     config: val.config,
    //     role: localRole,
    //     customer_id: val.user.customer_id,
    //     capabilities: val.capabilities,
    //   });
    //   this.venueIndex = val.venue_id;
    //   if (val.type == "device") {
    //     this.editDevicePortalPopup = true;
    //   } else if (val.type == "api") {
    //     this.apiPortalPopup = true;
    //   } else {
    //     this.editOnlinePortalPopup = true;
    //   }
    // },

    // deletePortal(val) {
    //   this.$vs.loading();
    //   _deletePortal(val.venue_id, val.id)
    //     .then(
    //       (response) => {
    //         this.$vs.loading.close();
    //         const selectedVenueIndex = this.venues.findIndex(
    //           (v) => v.id == val.venue_id
    //         );
    //         const selectedVen = this.venues[selectedVenueIndex];
    //         const selectedPortalIndex = selectedVen.portals.findIndex(
    //           (p) => p.id == val.id
    //         );
    //         this.venues[selectedVenueIndex].portals.splice(
    //           selectedPortalIndex,
    //           1
    //         );
    //         this.$vs.notify({
    //           title: response.data.responseTitle,
    //           text: response.data.responseMessage,
    //           iconPack: "feather",
    //           icon: "icon-check-circle",
    //           color: "success",
    //         });
    //       },
    //       (error) => {
    //         this.$vs.loading.close();
    //         this.$vs.notify({
    //           title: error.response.data.responseTitle,
    //           text: error.response.data.responseMessage,
    //           iconPack: "feather",
    //           icon: "icon-cross-circle",
    //           color: "danger",
    //         });
    //       }
    //     )
    //     .catch((error) => {
    //       this.$vs.loading.close();
    //       this.$vs.notify({
    //         title: error.response.data.responseTitle,
    //         text: error.response.data.responseMessage,
    //         iconPack: "feather",
    //         icon: "icon-cross-circle",
    //         color: "danger",
    //       });
    //     });
    // },

    // updatePortalSettings(response) {
    //   this.updatePortalRow(response.data.obj.portal);
    //   this.editDevicePortalPopup = false;
    //   this.venueIndex = -1;
    //   this.$store.dispatch("portalModule/resetPortal");
    // },

    // updatePortalRow(localPortal) {
    //   const selectedVenueIndex = this.venues.findIndex(
    //     (v) => v.id == localPortal.venue_id
    //   );
    //   const selectedVen = this.venues[selectedVenueIndex];
    //   const selectedPortalIndex = selectedVen.portals.findIndex(
    //     (p) => p.id == localPortal.id
    //   );
    //   this.$set(
    //     this.venues[selectedVenueIndex].portals,
    //     selectedPortalIndex,
    //     localPortal
    //   );
    // },

    // generateQR() {
    //   this.$vs.loading();
    //   _generateQR(this.venueIndex)
    //     .then(
    //       (response) => {
    //         this.$vs.loading.close();
    //         this.venue_qr_exists =  true
    //         this.selVen.qr_exists = 1;
    //       },
    //       (error) => {
    //         this.$vs.loading.close();
    //         this.$vs.notify({
    //           title: error.response.data.responseTitle,
    //           text: error.response.data.responseMessage,
    //           iconPack: "feather",
    //           icon: "icon-cross-circle",
    //           color: "danger",
    //         });
    //       }
    //     )
    //     .catch((error) => {
    //       this.$vs.loading.close();
    //       this.$vs.notify({
    //         text: error.message,
    //         iconPack: "feather",
    //         icon: "icon-cross-circle",
    //         color: "danger",
    //       });
    //     });
    // },

    // removeQR() {
    //   this.$vs.loading();
    //   _removeQR(this.venueIndex)
    //     .then(
    //       (response) => {
    //         this.$vs.loading.close();
    //         this.venue_qr_exists =  false
    //         this.selVen.qr_exists = 0


    //       },
    //       (error) => {
    //         this.$vs.loading.close();
    //         this.$vs.notify({
    //           title: error.response.data.responseTitle,
    //           text: error.response.data.responseMessage,
    //           iconPack: "feather",
    //           icon: "icon-cross-circle",
    //           color: "danger",
    //         });
    //       }
    //     )
    //     .catch((error) => {
    //       this.$vs.loading.close();
    //       this.$vs.notify({
    //         text: error.message,
    //         iconPack: "feather",
    //         icon: "icon-cross-circle",
    //         color: "danger",
    //       });
    //     });
    // },

  },
};
</script>

<style scoped>
/* Venues List Styles */
.venues-list-container {
  padding: 0;
}

.venues-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1rem 1.5rem;
  margin-bottom: 0;
}

.venues-title-section {
  display: flex;
  align-items: center;
}

.venues-title {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 600;
  color: #22292f;
}

.venues-table-wrapper {
  padding: 0;
}

.venues-table-wrapper >>> .vs-table {
  border-collapse: separate;
  border-spacing: 0 0.5rem;
}

.venues-table-wrapper >>> .vs-table--thead th {
  padding: 0.875rem 1rem;
  background: #f8f9fa;
  font-weight: 600;
  font-size: 0.8125rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #6e6b7b;
  border: none;
}

.venues-table-wrapper >>> .vs-table tbody tr {
  background: #fff;
  border: 1px solid #e4e4e4;
  border-radius: 0.375rem;
  transition: all 0.2s ease;
}

.venues-table-wrapper >>> .vs-table tbody tr:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  border-color: #7367f0;
}

.venues-table-wrapper >>> .vs-table tbody td {
  padding: 0.875rem 1rem;
  border: none;
  vertical-align: middle;
}


.wallet-amount {
  font-size: 0.9375rem;
  font-weight: 600;
  color: #28c76f;
}

.action-column {
  width: 1%;
  white-space: nowrap;
}

.action-btn {
  padding: 0.5rem 0.75rem !important;
  font-size: 0.8125rem !important;
}

@media (max-width: 768px) {
  .venues-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
    padding: 1rem;
  }

  .venues-table-wrapper >>> .vs-table tbody td {
    padding: 0.75rem 0.5rem;
    font-size: 0.8125rem;
  }

  .action-column {
    width: auto;
  }
}
</style>

